import Policies from "../../components/informative/policies";

export default function PoliciesPage() {
    return (
        <div>
            <Policies />
        </div>
    );
}